import { MouseEvent } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Typography } from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers'
import { useFormikContext } from 'formik'
import { Moment } from 'moment'

import { EAccountSubscriptionPlans, ISubscriptionGiftForm } from 'src/types'
import { SubscriptionPlanPicker } from '../account-billing/billing-modal/subscription-plan-picker.component'

import { useStyles } from './styles'
import { HelperWrapper } from 'src/components/helper-wrapper'

export const GiftForm = () => {
  const [t] = useTranslation()
  const classes = useStyles()
  const { values, setFieldValue, isSubmitting, errors } = useFormikContext<ISubscriptionGiftForm>()

  const handleSubscriptionChange = (
    _: MouseEvent<HTMLElement>,
    newSubscription: EAccountSubscriptionPlans,
  ) => {
    if (newSubscription !== null) {
      setFieldValue('subscriptionPlan', newSubscription)
    }
  }

  const handleDateChange = (date: Moment | null) => {
    setFieldValue('dueDate', date)
  }

  return (
    <div className={classes.form}>
      <Typography className={classes.formTitle} variant="h3">
        <HelperWrapper t="subscription-gift-form-title" />
      </Typography>
      <SubscriptionPlanPicker
        value={values.subscriptionPlan}
        handleChange={handleSubscriptionChange}
      />
      <DatePicker
        disablePast
        label={t('subscription-gift-date-input.v')}
        value={values.dueDate}
        onChange={handleDateChange}
        format="DD/MM/YYYY"
        closeOnSelect
        slotProps={{
          textField: {
            variant: 'standard',
            helperText: errors.dueDate ? <HelperWrapper t={String(errors.dueDate)} /> : '',
            FormHelperTextProps: {
              error: !!errors.dueDate,
            },
          },
        }}
      />
      <Button disabled={isSubmitting || !!Object.keys(errors).length} type="submit">
        <HelperWrapper t="subscription-gift-form-submit" />
      </Button>
    </div>
  )
}
